import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import RequestDetailsSideNav from 'app-ui-componentlibrary/dist/componentLibrary/sideNavWidgets/RequestDetailsSideNav';

export default connectDynamic(RequestDetailsSideNav);
